import type {
  LiveAlertPreferences,
  LiveAlertSettings,
  ResolvedLiveAlertChannel,
  ResolvedLiveAlertPreferences,
} from 'app/types/live-alerts'

/**
 * A single JSON blob rather than one key per switch, so the page reads and
 * writes the lot in one round trip.
 */
export const LIVE_ALERT_SETTINGS_KEY = `notifications.liveAlerts`

/**
 * Everything defaults to on: the cards and the chime shipped before this
 * setting did, so an absent value means "keep doing what you were doing".
 */
export function withLiveAlertDefaults(stored: LiveAlertPreferences | undefined): LiveAlertSettings {
  return {
    enabled: stored?.enabled ?? true,
    newTextMessage: {
      popup: stored?.newTextMessage?.popup ?? true,
      sound: stored?.newTextMessage?.sound ?? true,
    },
    incomingCall: {
      popup: stored?.incomingCall?.popup ?? true,
      sound: stored?.incomingCall?.sound ?? true,
    },
  }
}

/**
 * The section switch is a master, so it silences everything while leaving the
 * individual values intact for when it comes back on. A sound behind a popup
 * that will not appear resolves to off: only a card being added plays the chime.
 */
export function resolveLiveAlertPreferences(stored: LiveAlertPreferences | undefined): ResolvedLiveAlertPreferences {
  const { enabled, newTextMessage, incomingCall } = withLiveAlertDefaults(stored)
  const resolve = (channel: ResolvedLiveAlertChannel): ResolvedLiveAlertChannel => {
    const popup = enabled && channel.popup
    return { popup, sound: popup && channel.sound }
  }
  return { sms: resolve(newTextMessage), calls: resolve(incomingCall) }
}
